<template>
    <div class="content with-pagination">
        <router-view @refresh="refresh()"></router-view>
        <header class="content-header">
            <div class="wrapper">

                <div>
                    <h1>Produits</h1>
                    <p>Gestion des commandes</p>

                    <div class="datagrid-results"><strong>{{paginator.total}}</strong> Résultats trouvés</div>
                </div>


              <actions-dropdown>
                <li v-if="$aclInterfaceValidator('weeboxshop.product.create')" class="main" @click="create()">
                  <icon name="file-plus-02"/>
                  <span>Créer un produit</span>
                </li>
                <li v-if="$aclInterfaceValidator('weeboxshop.product.export')" @click="exportFile('categories')">
                  <icon name="download-cloud-01"/>
                  <span>Export les résultats (Excel)</span>
                </li>
                <li v-if="$aclInterfaceValidator('weeboxshop.product.import')" @click="importFile()">
                  <icon name="upload-cloud-01"/>
                  <span>Importer</span>
                </li>
                <li @click="clearCache()">
                  <icon name="refresh-cw-05"/>
                  <span>Supprimer le cache</span>
                </li>
                <li @click="rss()">
                  <icon name="rss-01"/>
                  <span>Flux RSS</span>
                </li>
              </actions-dropdown>


            </div>
        </header>

        <filters v-model="filters" :paginator="paginator" :tabs="tabs" active-advanced-filter="false" active-tabs="false" @refresh="refresh()" @setFilter="setFilter"></filters>

        <div class="content-body">

            <section>

            <no-results v-model="resources" :clear="resetFilter"></no-results>

            <div v-if="resources && resources.length" class="datagrid" :class="paginator.listing">
                <div class="datagrid-header">
                    <div>
                        <div></div>
                        <div class="picture"></div>
                      <div class="center">
                        <datagrid-sort :data="[{name:'ID', value:'id'}]" v-model="paginator"></datagrid-sort>
                      </div>
                        <div>
                          <datagrid-sort label="Nom" :data="[{name:'Nom', value:'name'}]" v-model="paginator"></datagrid-sort>
                        </div>
                        <div class="right">
                          <datagrid-sort label="Prix" :data="[{name:'Prix brut', value:'amount_selling_price'}, {name:'Coût de revient', value:'amount_cost_price'}, {name:'Donation', value:'amount_donation'}]" v-model="paginator"></datagrid-sort>
                        </div>
                        <div class="center"><span>Stock</span></div>
                        <div><span>Statut</span></div>
                        <div>
                          <datagrid-sort label="Dernière modification" :data="[{name:'Dernière modification', value:'updated_at'}]" v-model="paginator"></datagrid-sort>
                        </div>
                        <div><span>Scope</span></div>
                        <div class="actions"></div>
                        <div></div>
                    </div>
                </div>
                <div class="datagrid-body">
                    <div v-for="item in resources" @dblclick="edit(item.id)" v-bind:class="setClassDataRaw( 'weeboxshop.product.view', item.id )">
                        <div></div>
                        <div class="picture no-radius big">
                            <figure>
                                <i v-if="!item.medias[0]" class="icon icon-icon_picture"></i>
                                <img v-if="item.medias[0]" :src="item.medias[0].url+'/fit/100x100'"/>
                            </figure>
                        </div>
                      <div data-field="id" class="center"><span class="id">{{ item.id }}</span></div>
                        <div data-field="name">
                            <span style="text-transform: uppercase; font-size: 10px; font-weight: 600; display: block; margin-bottom: 4px; opacity: 0.6;" v-if="item.brand">{{ item.brand.name }}</span>
                            <strong class="highlight">{{ item.name }} <sup v-if="item.is_new" class="badge-new">NEW</sup></strong>
                            <p v-if="item.sku" style="font-weight:400;">{{ item.sku }}</p>
                            <p v-if="item.sku_supplier">{{ item.sku_supplier }}</p>
                          <div style="margin-top: 0.5em;"><product-type :value="item"></product-type></div>
                        </div>
                      <div data-field="amount_selling_price" class="right" style="white-space: nowrap;">
                        <span class="price highlight"><i>{{ $store.state.scope.currency_id }}</i> {{ item.amount_selling_price|formatNumber }}</span>
                        <span class="price"><i>{{ $store.state.scope.currency_id }}</i> {{ item.amount_cost_price|formatNumber }}</span>
                        <span class="price"><i>{{ $store.state.scope.currency_id }}</i> {{ item.amount_donation|formatNumber }}</span>
                      </div>
                        <div class="center">{{ item.unlimited_stock ? "∞" : (item.stock ? item.stock.quantity : null) }}</div>
                        <div><published v-model="item.published" :date-start="item.start_at" :date-end="item.end_at"></published></div>
                        <div data-field="updated_at"><date v-model="item.updated_at"></date></div>
                        <div data-field="scope"><scopes v-model="item.scopes" v-if="item.scopes"></scopes></div>
                        <div class="actions">
                            <ul v-if="paginator.filter == 'only_trashed'">
                                <li v-if="$aclInterfaceValidator('weeboxshop.product.delete',item.id)"><button @click="forceDelete(item.id)"><icon name="trash-01"/></button></li>
                                <li v-if="$aclInterfaceValidator('weeboxshop.product.update',item.id)"><button @click="restore(item.id)"><i class="icon icon-icon_refresh"></i></button></li>
                            </ul>
                            <ul v-else>
                                <li v-if="$aclInterfaceValidator('weeboxshop.product.delete', item.id)"><button @click="remove(item.id)"><icon name="trash-01"/></button></li>
                                <li v-if="$aclInterfaceValidator('weeboxshop.product.update', item.id) && item.parent_id === null"><button @click="duplicate(item.id)" title="Dupliquer"><icon name="copy-07"/></button></li>
                                <li v-if="$aclInterfaceValidator('weeboxshop.product.update', item.id)"><button @click="edit(item.id)"><icon name="pencil-02"/></button></li>
                            </ul>
                        </div>
                        <div></div>
                    </div>
                </div>
            </div>
            </section>

            <component-paginator v-model="paginator" v-on:refresh="refresh"></component-paginator>

        </div>
    </div>
</template>
<script>
    import ProductService from './ProductService.js';
    import Index from '../../../layouts/Index.vue';

    export default {
        extends: Index,
        data () {
            return {
                tabs: [
                    {
                        slug: '',
                        name: 'Tous'
                    },
                    {
                      slug: 'only_product',
                      name: 'Produit'
                    },
                    {
                      slug: 'only_template',
                      name: 'Template'
                    },
                    {
                      slug: 'only_variant',
                      name: 'Variante'
                    },
                    {
                        slug: 'only_trashed',
                        name: 'Corbeille'
                    }
                ]
            }
        },
        mounted: function(){
            this.refresh()
        },
        methods: {
            getResource: function(){
                return ProductService;
            },
            rss: function(){
                window.open(window.apiUrl + this.$store.state.path + "/v1/public/shop/catalog/products/rss?lang=fr");
            },
            clearCache: function(){
                window.open(window.apiUrl + this.$store.state.path + "/update-scope-catalog");
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/shop/product/Index.vue